import script from "./GroupsDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupsDetailsView.vue?vue&type=script&setup=true&lang=ts"

import "./GroupsDetailsView.vue?vue&type=style&index=0&id=7720e579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7720e579"]])

export default __exports__